import React from "react"
import { styled } from "styled-components"
import { CustomerContainer } from "./CustomerContainer"
import { white } from "./components/colors"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  color: ${white};
  overflow-y: auto;
  align-items: center;
  gap: 48px;
  padding-top: 72px;
  padding-bottom: 72px;
`

export const AdminContainer: React.FC = () => {
  return (
    <Container>
      <CustomerContainer />
    </Container>
  )
}
